// keep in sync with the limits of internal/services/help_request_service.go
export const HELP_REQUEST_SUBJECT_MAX_LENGTH = 200;
export const HELP_REQUEST_MESSAGE_MAX_LENGTH = 5000;
export const HELP_REQUEST_MAX_ATTACHMENTS = 3;
export const HELP_REQUEST_MAX_ATTACHMENTS_MEGABYTES = 5;
export const HELP_REQUEST_MAX_ATTACHMENTS_SIZE = HELP_REQUEST_MAX_ATTACHMENTS_MEGABYTES * 1024 * 1024;
